import { useState } from 'react'
import { useAsyncEffect } from 'utils'
import { MediaInfo } from '../../../types'
import { mediaInfoFromSource } from '../../../utils/media'

export function useMediaInfo(source: File | string) {
    const [state, setState] = useState<MediaInfo | null>(null)

    useAsyncEffect(async () => {
        if (!source) {
            setState(null)
        } else {
            const mediaInfo = await mediaInfoFromSource(source)

            if (mediaInfo) {
                if (mediaInfo.type === 'video') {
                    mediaInfo.fps = 30
                } else {
                    mediaInfo.fps = Math.max(mediaInfo.fps || 0, 12)
                }
            }

            setState(mediaInfo)
        }
    }, [source])

    return state
}
